"use client";
import { j as e } from "./index.es73.js";
import { forwardRef as b } from "react";
import { composeClassNames as c } from "./index.es139.js";
import p from "./index.es140.js";
b(
  ({
    label: a,
    value: r,
    placeholder: i,
    onChange: o,
    state: l,
    message: s,
    isDisabled: m,
    ...t
  }, d) => /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("label", { className: "bl-size-6 bl-display-block", children: [
    a,
    /* @__PURE__ */ e.jsx(
      "textarea",
      {
        ...t,
        ref: d,
        className: c(
          "bl-input",
          l && `bl-input--${l}`,
          "bl-m-t-1",
          "bl-p-y-3"
        ),
        onChange: o,
        value: r,
        disabled: m,
        placeholder: i
      }
    ),
    s && /* @__PURE__ */ e.jsx("div", { className: "bl-p-t-1", children: /* @__PURE__ */ e.jsx(p, { state: l, children: s }) })
  ] }) })
);
//# sourceMappingURL=index.es77.js.map
